export const demoTheme = {
    primary: "#166341",
    accent: "#9D3C21",
    background: "#E8F7EE",
    card: "#ffffff",
    text: "#102F28",
    mutedText: "#50665B",
    buttonText: "#ffffff",
    progress: "#166341",
    border: "#B4CCBD",
    radius: "8px",
    fontFamily: "Manrope, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    headlineScale: 1,
    bodyScale: 1,
    spacingDensity: "comfortable",
    answerWeight: 560
};
